import React, { useContext } from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import { CanvasContext } from "../contexts/CanvasContext";


const ConceptScriptPanel = ({ designConcept, setDesignConcept, onClose }) => {

    const { conceptSummary,
        layers, selectedSegments, setSelectedSegments, getComputedTransformValues,API_URL,
        setLoading, setRoleGroupSummary, setElementOffsets, setConceptSummary, setConcept, setOverlayMessage, layoutType, fetchData, autoStartAnimation } = useContext(CanvasContext);


    const generateAnimationGivenConcept = async () => {


        setRoleGroupSummary({});
        setElementOffsets({});
        setConceptSummary({});

        setLoading(true);

        const layerStates = layers.map(layer => {
            const element = document.getElementById(layer.id);
            const transformValues = getComputedTransformValues(element);

            return {
                id: layer.id,
                left: element.style.left,
                top: element.style.top,
                width: element.style.width,
                height: element.style.height,
                zIndex: element.style.zIndex,
                transform: {
                    translateX: transformValues.translateX,
                    translateY: transformValues.translateY,
                    scaleX: transformValues.scaleX,
                    scaleY: transformValues.scaleY
                },
                src: layer.src,
                alt: layer.alt,
                role: layer.role,
                group: layer.group
            };
        });

        try {
            const response = await fetch(`${API_URL}/generate_animation`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ layers: layerStates, layoutType }),
            });

            const data = await response.json();

            setConceptSummary(data.concept_summary);

            setConcept(data.concept);

            // This will not change
            let currentRun = data.run;

            // This will change
            let nextRun = data.run;

            // Always stays the same
            let filename = data.filename;

            setOverlayMessage(`Animation First Draft `);
            // alert("start animation");
            await autoStartAnimation(data.logo_animation);

            await fetchData();
            setLoading(false);



        } catch (error) {
            console.error('Error suggesting a design concept :', error);
        }
    };

    const handleChange = (e) => {
        setDesignConcept(e.target.value); // Update the state when the user edits the value
      };

    return (
        <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, fontSize: '2em', height: '50%', width: '40%', padding: 2, backgroundColor: 'black', color: 'white', overflowY: 'scroll' }}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
                <Typography variant="h5" gutterBottom>
                    Design Concept
                </Typography>
                <Button variant="contained" color="secondary" onClick={onClose}>
                    Close
                </Button>
                <Button color="secondary" variant="contained" onClick={generateAnimationGivenConcept}>
                    <AutoFixHighIcon /> Generate Given Concept
                </Button>
            </Box>
            <textarea
                value={designConcept}
                onChange={handleChange}

                style={{
                    width: '100%',
                    height: '100%',
                    backgroundColor: '#282a36',
                    color: '#',
                    padding: '10px',
                    borderRadius: '5px',
                    border: 'none',
                    resize: 'none',
                }}
            />    </Paper>
    );
};

export default ConceptScriptPanel;
